import { ProgressBar} from "react-bootstrap";

function RevenueRiskEntity({ chart_data }) {
  const data = Array.isArray(chart_data) ? chart_data : [];

  if (!data.length) {
    return <div className="text-muted">No Data Available</div>;
  }
  const totalRevenue = data.reduce(
    (sum, item) => sum + Number(item?.revenue || 0),
    0
  );
  const colors = [
    "success",
    "info",
    "warning",
    "danger",
    "primary",
    "secondary",
  ];

  const toLakhs = (amount) => {
    const lakhs = amount / 100000; // 1 Lakh = 100000
    return lakhs.toFixed(2);
  };

  return (
    <div className="justify-content-center">
      {chart_data.map((item, index) => {
        const revenue = Number(item.revenue) || 0;
        const percentage =
          totalRevenue > 0 ? (revenue / totalRevenue) * 100 : 0;

        return (
          <div key={index} className="mb-3">
            <p className="fs-15 fw-light mb-0 text-muted">
              <strong>{item.entityName}</strong>
              <span className="float-end fs-12 fw-normal">
                ₹ {toLakhs(revenue)} L | {item?.invoiceCount || 0} Invoices
              </span>
            </p>

            <ProgressBar
              className="custom-progress"
              max={100}
              now={percentage}
              variant={colors[index % colors.length]}
              label={
                percentage > 10 ? `${percentage.toFixed(2)}%` : null
              }
            />
          </div>
        );
      })}
    </div>
  );
}

export default RevenueRiskEntity;